import React from 'react'
import './price-block.scss'

const PriceBlock = () => {


    return (
        <div id="price" className='price-block'>
            <div className="container price-block__inner">
                <div className="price-block__top" data-aos="fade-up">
                    <h3 className='price-block__title title'>Pick your trading account!</h3>
                </div>

                <div className="price-block__wrapper">

                    <div className="price-block__item" data-aos="fade-up">
                        <div className="price-block__item-top">
                            <span className="price-block__item-title">Silver</span>
                            <div className="price-block__price">$100</div>
                        </div>

                        <div className="price-block__item-text">An excellent choice for beginner traders, offering tight spreads from 1.2 pips on MT4 and MT5 platforms, along with micro-lot trading.
                            Open account</div>

                        <a href="#" rel="noreferrer" target="_blank"  className="price-block__item-button button">Open account</a>

                    </div>

                    <div className="price-block__item" data-aos="fade-up">
                        <div className="price-block__item-top">
                            <span className="price-block__item-title">Gold</span>
                            <div className="price-block__price">$500</div>
                        </div>

                        <div className="price-block__item-text">Advanced features for experienced traders: low spreads from 1.2 pips, access to additional tools, and flexible trading conditions.
                            Open account</div>

                        <a href="#" rel="noreferrer" target="_blank"  className="price-block__item-button button">Open account</a>

                    </div>

                    <div className="price-block__item" data-aos="fade-up">
                        <div className="price-block__item-top">
                            <span className="price-block__item-title">Platinum</span>
                            <span className="price-block__price">$1500</span>
                        </div>

                        <div className="price-block__item-text">A premium account with exclusive benefits: minimal spreads, high-speed order execution, and priority 24/7 support.</div>

                        <a href="#" rel="noreferrer" target="_blank"  className="price-block__item-button button">Open account</a>

                    </div>

                </div>
            </div>

        </div>
    )
}

export default PriceBlock